"use strict";

/**
 * @mixes QuartoMap~Props
 */
class QuartoMap {
    constructor(props) {
        _.merge(this, props);
    }
}

class QuartoMapCenter {
    /**
     * @param {string} title
     * @param {google.maps.LatLng} centerPoint
     */
    constructor(title, centerPoint) {
        this._title = title;
        this._centerPoint = centerPoint;
    }

    /**
     * @returns {string} Title of the center point.
     */
    get title() {
        return this._title;
    }

    /**
     * @returns {google.maps.LatLng} Center point.
     */
    get centerPoint() {
        return this._centerPoint;
    }
}

/**
 * Static property of `QuartoMap`, moved out from class declaration because it is not supported in Safari 14.3.
 * @see https://developers.google.com/maps/documentation/javascript/tutorial#zoom-levels
 */
QuartoMap.ZOOM = Object.freeze({
    Continent: 6,
    Estate: 13,
});

/**
 * @example
 * $compile(`<div quarto-map="myMap"></div>`)($scope);
 * $scope.myMap instanceof QuartoMap; // true
 *
 * Style reference to `app/content/css/quarto-map.css`.
 */
app.directive("quartoMap", function quartoMapDirective(
    $rootScope, $compile, $http, $timeout, $ocLazyLoad, $q, mapService, authService, controlService, broadcastService, MAPCONSTANT) {

    const DEFAULT_FILTER_PANEL_WIDTH = `${MAPCONSTANT.FILTER_WIDTH.NORMAL}px`;
    const DEFAULT_INFO_PANEL_WIDTH = `${MAPCONSTANT.INFO_WIDTH}px`;
    const MESSAGE_FILL_HEIGHT_MISUSE = `\
quarto-map's "fill-height" attribute only works when its parent element has "ng-controller" attribute.

Working: 
<div ng-controller="myController">
    <div quarto-map fill-height></div>
</div>

Not working:
<div ng-controller="myController">
    <div>
        <div quarto-map fill-height></div>
    </div>
</div>`;

    return {
        restrict: "EA",

        /**
         * # ISSUE:
         * `q-scope-field` is not yet assigned in $scope.createNewEntryFromUQF if we use `templateURL`
         * `templateURL` only works when <div quarto-map></div> is not a nested element.
         *
         * ## How to reproduce the issue
         * So far we tested that when <div quarto-map></div> is at least 3 levels nested,
         * linker function call is delayed, causing `q-scope-field` only available at
         * a later time. (specifically, after $scope.createNewEntryFromUQF)
         *
         * ## Strange behavior
         * From angular-js [documentation](https://code.angularjs.org/1.2.32/docs/api/ng/service/$compile)
         * `templateURL` should be always asynchronous, but it is not the case when quarto-map is not
         * deeply nested (tried with slower internet in Chrome Developer Tool).
         *
         * ## Cross check with kendo-ui implementation
         * As `q-scope-field` is inspired by kendo-ui, we cross verified that
         * [kendo-ui-core/2016.3.1118](https://github.com/telerik/kendo-ui-core/tree/2016.3.1118/docs/api/javascript)
         * is not implemented with `template` instead of `templateURL` too.
         */
        template: `
            <div class="q-map-root">
                <div id="map-google-background" class="q-map-gmap-background">
                    <h4 ng-bind="_quartoMapValues.welcomeText"></h4>
                    <img src="data:image/svg+xml;base64,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" alt=""">
                </div>
                <div id="map-google" class="q-map-gmap"></div>
                <div class="q-map-panels">
                    <div class="q-map-left-panel">
                        <div id="map-info"></div>
                    </div>
                    <div id="map-content" class="q-map-center-panel">
                        <div class="q-map-relocate" 
                             ng-class="{'q-map-control-fade': _quartoMapValues.isInfoOpen}" 
                             ng-show="_quartoMapValues.centers" 
                             ng-click="_quartoMapCallbacks.relocate();" 
                             title="{{ _quartoMapValues.relocateTitle }}">
                            <div></div>
                        </div>
                        
                        <div class="q-map-relocate-options-arrow-right" ng-if="_quartoMapValues.isShowCenters"></div>
                        <div class="q-map-relocate-options" ng-if="_quartoMapValues.isShowCenters">
                            <div class="list-group">
                                <button type="button" 
                                        class="q-map-relocate-options-items list-group-item"
                                        ng-repeat="center in _quartoMapValues.centers" 
                                        ng-click="_quartoMapCallbacks.relocateToIndex($index);">
                                    <div class="q-map-relocate-options-text">{{ center.title }}</div>
                                </button>
                            </div>
                        </div>
                        
                        <div id="map-zoom" ng-class="{'q-map-control-fade': _quartoMapValues.isInfoOpen}"> 
                            <!-- This whole chunk copied directly from Google Map. -->
                            <div class="map-zoom-controls" draggable="false">
                                <button ng-click="_quartoMapCallbacks.zoomIn();" draggable="false" title="Zoom in" aria-label="Zoom in" type="button">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A" alt="+">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23333%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A" alt="+">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpolygon%20fill%3D%22%23111%22%20points%3D%2218%2C7%2011%2C7%2011%2C0%207%2C0%207%2C7%200%2C7%200%2C11%207%2C11%207%2C18%2011%2C18%2011%2C11%2018%2C11%22%2F%3E%0A%3C%2Fsvg%3E%0A" alt="+">
                                </button>
                                <div></div>
                                <button ng-click="_quartoMapCallbacks.zoomOut();" draggable="false" title="Zoom out" aria-label="Zoom out" type="button">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23666%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A" alt="-">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23333%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A" alt="-">
                                    <img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%0A%20%20%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%2C7h18v4H0V7z%22%2F%3E%0A%3C%2Fsvg%3E%0A" alt="-">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="q-map-right-panel">
                        <div class="q-map-right-panel-child-1" title="Show/Hide Filters">
                            <div class="filter-toggle"
                                 ng-click="_quartoMapValues.isFilterOpen = !_quartoMapValues.isFilterOpen"
                                 ng-bind-html="_quartoMapValues.isFilterOpen ? '&#9658;' : '&#9668;'"></div>
                        </div>
                        <div class="q-map-right-panel-child-2">
                            <div id="map-filter"></div>
                        </div>
                    </div>
                </div>
            </div>
        `,

        link: ($scope, iElement, iAttrs) => {
            // Get all DOM attributes.
            const openFilterField = _.get(iAttrs, "qOpenFilter") || _.get(iAttrs, "openFilter");
            const directiveName = _.get(iAttrs, "quartoMap") || _.get(iAttrs, "qScopeField") || _.get(iAttrs, "scopeField");
            const shouldFillHeight = _.some([_.get(iAttrs, "qFillHeight"), _.get(iAttrs, "fillHeight")],
                val => !_.isUndefined(val));
            const welcomeText = $scope.$eval(_.get(iAttrs, "qWelcomeText", "") || _.get(iAttrs, "welcomeText", ""));
            // Optional rendering type. Defaults to Google Map's vector rendering when not specified.
            // Use "raster" to opt out of vector rendering. This avoids a Google Maps bug where a freshly
            // created vector map (sharing the same mapId) silently fails to render AdvancedMarkerElement
            // content when a previous vector map is torn down at the same time (e.g. on tab close/reopen).
            const renderingTypeAttr = _.toLower(_.get(iAttrs, "qRenderingType", "") || _.get(iAttrs, "renderingType", ""));

            const _quartoMapValues = {
                isFilterOpen: _.isEmpty(openFilterField) ? true : Boolean($scope[openFilterField]),
                isInfoOpen: false,
                filterWidth: DEFAULT_FILTER_PANEL_WIDTH,
                infoWidth: DEFAULT_INFO_PANEL_WIDTH,
                welcomeText,
                centers: null,
                isShowCenters: false
            };
            _.assign($scope, {_quartoMapValues});

            // Bind the value of `$scope[openFilter]` and `$scope["_quartoMapValues.isFilterOpen"]`. 
            if (!_.isEmpty(openFilterField)) {
                const fields = ["_quartoMapValues.isFilterOpen", openFilterField];
                $scope.$watchGroup(fields, (newValues, oldValues) => {
                    _.map(fields, (field, i) => {
                        const next = (i + 1) % _.size(fields);
                        const [newVal, oldVal] = [Boolean(newValues[next]), Boolean(oldValues[next])];
                        if (newVal !== oldVal) $scope[field] = newVal;
                    });
                });
            }

            const eventChannels = lm.createEventChannels();

            const _mapAreas = {
                "map-background": iElement.find("#map-google-background"),
                "map": iElement.find("#map-google"),
                "info": iElement.find("#map-info"),
                "content": iElement.find("#map-content"),
                "filter": iElement.find("#map-filter"),
            };

            $scope.$watchGroup([
                    "_quartoMapValues.isInfoOpen",
                    "_quartoMapValues.isFilterOpen",
                    "_quartoMapValues.infoWidth",
                    "_quartoMapValues.filterWidth",
                ],
                ([
                     isInfoOpen,
                     isFilterOpen,
                     infoWidth,
                     filterWidth,
                 ]) => {
                    _mapAreas["info"].width(isInfoOpen ? infoWidth : "0");
                    _mapAreas["filter"].parent().width(isFilterOpen ? filterWidth : "0");
                    eventChannels.broadcast("info", isInfoOpen);
                    eventChannels.broadcast("filter", isFilterOpen);
                });

            const lazyGeopointsLoaders = {};

            /**
             * @mixin QuartoMap~Props
             */
            const quartoMap = new QuartoMap({
                /**
                 * gMap event.
                 *
                 * @example
                 * quartoMap.addListener("gMap", gMap => { ... });
                 *
                 * @event QuartoMap#gMap
                 * @type {null|google.maps.Map}
                 */

                /**
                 * Info open/close event
                 *
                 * @example
                 * quartoMap.addListener("info", isInfoOpen => { ... });
                 *
                 * @event QuartoMap#info
                 * @type {boolean}
                 */

                /**
                 * Filter open/close event.
                 *
                 * @example
                 * quartoMap.addListener("filter", isFilterOpen => { ... });
                 *
                 * @event QuartoMap#filter
                 * @type {boolean}
                 */

                /**
                 * onDestroy event.
                 *
                 * Trigger before gMap is being destroyed.
                 *
                 * @example
                 * quartoMap.addListener("onDestroy", () => { ... });
                 *
                 * @event QuartoMap#onDestroy
                 */

                /**
                 * @type {Object}
                 * For mixins development only. Provides dependencies.
                 */
                _deps: {
                    $rootScope,
                    $scope,
                    $http,
                    $compile,
                    $timeout,
                    $q,
                    mapService,
                    authService,
                    controlService,
                    MAPCONSTANT,
                    eventChannels
                },

                /**
                 * @type {jQuery}
                 * Access to QuartoMap DOM root element.
                 */
                element: iElement,

                /**
                 * @type {null|google.maps.Map}
                 * This value only available after your first call to `setOptions`.
                 */
                gMap: null,

                /**
                 * Load all Google Map libraries and common mixins for QuartoMap.
                 * @return {Promise<void>}
                 */
                async loadLibs() {
                    return $.when(
                        mapService.lazyLoadLibs(),
                        $ocLazyLoad.load("/app/components/map/quartoMapFilter.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapInfo.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapNotification.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapOuMarker.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapSwitch.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapLegend.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapLabels.js"),
                        $ocLazyLoad.load("/app/components/map/quartoMapPromptMarkGeopoint.js"),
                        $ocLazyLoad.load("/content/css/map/q-map-switch.css"),
                        $ocLazyLoad.load("/content/css/map/q-map-legend.css"),
                        $ocLazyLoad.load("/content/css/map/q-map-notifications.css"),
                        $ocLazyLoad.load("/content/css/map/q-map-prompt-mark-geopoint.css"),
                    );
                },

                /**
                 * @typedef QuartoMap~CenterPoint
                 * @property {number} Lat
                 * @property {number} Lng
                 */

                /**
                 * @typedef QuartoMap~Geopoints~OUSetup
                 * @property {number} OUKey
                 * @property {string} OUCode
                 * @property {QuartoMap~CenterPoint} CenterPoint
                 */

                /**
                 * @typedef QuartoMap~Geopoints~DivSetup
                 * @property {number} OUKey
                 * @property {number} DivKey
                 * @property {string} DivCode
                 * @property {QuartoMap~CenterPoint} CenterPoint
                 */

                /**
                 * @typedef QuartoMap~Geopoints~BlockSetup
                 * @property {number} OUKey
                 * @property {number} BlockKey
                 * @property {number} DivKey
                 * @property {string} BlockCode
                 * @property {number} PlantedYr
                 * @property {string} PlantMateCode
                 * @property {QuartoMap~CenterPoint} CenterPoint
                 */

                /**
                 * @typedef QuartoMap~Geopoints
                 * @property {QuartoMap~Geopoints~OUSetup[]} OUSetups
                 * @property {QuartoMap~Geopoints~DivSetup[]} DivSetups
                 * @property {QuartoMap~Geopoints~BlockSetup[]} BlockSetups
                 */

                /**
                 * Load all geopoints.
                 * @param {string[]} [config?.blockTypes=["M"]] - Accepted values are "M"(Mature), "RP"(Replanting), "NP"(New planting), and "F"(Felling).
                 * @param {boolean[]} [config?.activeness=[true]]] - To retrieve active or inactive blocks.
                 * @param {boolean} [config?.isScoutHar=false]] - To retrieve isScoutHar blocks or not.
                 * @param {int} [config?.yr=0]] - To retrieve block in mth end yield table based on filter yr/mth
                 * @param {int} [config?.mth=0]] - To retrieve block in mth end yield table based on filter yr/mth
                 * @param {date} [config?.queryDate=new Date(Date.now())]] - To retrieve block in mth end yield table based on filter yr/mth
                 @return {Promise<QuartoMap~Geopoints>}
                 */
                async loadGeopoints(config) {
                    const clonedBlockTypes = _.clone(_.get(config, "blockTypes", ["M"]));
                    const clonedActiveness = _.clone(_.get(config, "activeness", [true]));
                    const clonedIsScoutHar = _.clone(_.get(config, "isScoutHar", false));
                    const clonedYr = _.clone(_.get(config.period, "fy", 0));
                    const clonedMth = _.clone(_.get(config.period, "period", 0));
                    const cloneQueryDate = _.clone(_.get(config.period, "queryDate", new Date(1900, 1, 1)));
                    clonedBlockTypes.sort();
                    clonedActiveness.sort();
                    const key = clonedBlockTypes.join(",") + clonedActiveness.join(",") + "," + clonedYr + "," + clonedMth + "," + cloneQueryDate;
                    if (!_.has(lazyGeopointsLoaders, key)) {
                        lazyGeopointsLoaders[key] = lm.lazyAsync(async () => {
                            return (await $http({
                                url: `${$rootScope.masterWebApiUrl}Map/GeopointSetup/GetGeopoints`,
                                responseType: "json",
                                params: {
                                    blockTypes: clonedBlockTypes,
                                    activeness: clonedActiveness,
                                    isScoutHar: clonedIsScoutHar,
                                    yr: clonedYr,
                                    mth: clonedMth,
                                    queryDate: cloneQueryDate,
                                }
                            })).data;
                        });
                    }
                    return lazyGeopointsLoaders[key].value;
                },

                /**
                 * Set Google Map options, can call multiple times.
                 * Value of `gMap` only assigned after this function is called once.
                 * Make sure libraries are loaded with `loadLibs` before you call this function.
                 *
                 * @param {QuartoMapCenter | QuartoMapCenter[]} [options.centers] - Center point or a list of center points.
                 * @param {number} [options.zoom] - Pan to this zoom level.
                 * @param {boolean | number} [options.panToCenter=20000] - Force pan to nearest center if set to true; or false
                 *                                                         to never pan. If [number value] is
                 *                                                         given, only pan to nearest center if distance between
                 *                                                         given and nearest center is gte
                 *                                                         to given [number value], unit in meters.
                 */
                setOptions(options) {
                    const mapElement = _mapAreas["map"][0];

                    // @type {?QuartoMapCenter[]}
                    const centers = (() => {
                        const tmp = _.castArray(_.get(options, "centers") || []);
                        return _.isEmpty(tmp) ? null : tmp;
                    })();
                    const ouWithoutGeopoint = centers.filter(a => _.isNil(a._centerPoint)).map(a => a._title);
                    if (ouWithoutGeopoint.length === centers.length) {
                        const csvBlock = ouWithoutGeopoint.join(", ");
                        const msg = `Error: The OU(s) without Geopoint: ${csvBlock}. Please setup the Geopoint at the Operating Unit Setup form.`;
                        this.notify(msg);
                    }
                    else if (ouWithoutGeopoint.length){
                        const csvBlock = ouWithoutGeopoint.join(", ");
                        const msg = `Warning: The OU(s) without Geopoint: ${csvBlock}. Please setup the Geopoint at the Operating Unit Setup form.`;
                        this.notify(msg);
                    }

                    const zoom = _.get(options, "zoom");
                    const panToCenter = _.get(options, "panToCenter", 20000);

                    _.set($scope, "_quartoMapValues.centers", centers);
                    _.set($scope, "_quartoMapValues.relocateTitle",
                        _.isNull(centers) || _.size(centers) > 1 ? "Relocate" : `Relocate to ${_.first(centers).title}`);

                    if (!this.gMap) {
                        // Remove map background.
                        _mapAreas["map-background"].remove();
                        delete _mapAreas["map-background"];

                        const _center = (() => {
                            if (!_.isNull(centers))
                                return _.first(centers).centerPoint;
                            // Kota Kinabalu, zoom level continent
                            return new google.maps.LatLng(-0.3076157096439005, 106.5234375);
                        })();

                        const gMap = this.gMap = new google.maps.Map(mapElement, {
                            center: _center,
                            zoom: zoom || !_.isNull(centers) ? QuartoMap.ZOOM.Estate : QuartoMap.ZOOM.Continent,
                            zoomControl: false,
                            scaleControl: true,
                            clickableIcons: false,
                            streetViewControl: false,
                            fullscreenControl: false,
                            minZoom: 3,
                            mapTypeId: google.maps.MapTypeId.HYBRID,
                            mapId: "71d9ed2b39d993a582340272",
                            mapTypeControlOptions: {
                                mapTypeIds: []
                            },
                            ...(renderingTypeAttr === "raster"
                                ? { renderingType: google.maps.RenderingType.RASTER }
                                : {})
                        });

                        const _quartoMapCallbacks = {
                            zoomIn: () => gMap.setZoom(gMap.getZoom() + 1),
                            zoomOut: () => gMap.setZoom(gMap.getZoom() - 1),
                            relocate: () => {
                                const centers = this.getCenters();
                                if (!(centers && gMap))
                                    return;
                                if (_.size(centers) === 1 && _.first(centers).centerPoint)
                                    gMap.panTo(_.first(centers).centerPoint);
                                else
                                    _.set($scope._quartoMapValues, "isShowCenters", !$scope._quartoMapValues.isShowCenters);
                            },
                            relocateToIndex: (i) => {
                                const centers = this.getCenters();
                                gMap.panTo(centers[i].centerPoint);
                                _.set($scope._quartoMapValues, "isShowCenters", false);
                            }
                        }
                        _.assign($scope, {_quartoMapCallbacks});

                        eventChannels.subscribe("gMap", _gMap => {
                            const visibility = _gMap ? "visible" : "hidden";
                            iElement.find("#map-zoom").css("visibility", visibility);
                        });

                        // Register on-click/esc to set `_quartoMapValues.isShowCenters` to `false`
                        let eventHandlerId = null;
                        eventChannels.subscribe("gMap", _gMap => {
                            if (_gMap) {
                                if (_.isNil(eventHandlerId)) {
                                    eventHandlerId = broadcastService.guid();
                                    $(document)
                                        .on(`click.gmap-${eventHandlerId}`, function (event) {
                                            const $target = $(event.target);
                                            const closeToRelocate = $target.closest('.q-map-relocate').length;
                                            const closeToRelocateOptions = $target.closest('.q-map-relocate-options').length;
                                            if (!(closeToRelocate || closeToRelocateOptions) &&
                                                $scope._quartoMapValues.isShowCenters) {
                                                $scope.$apply(() => {
                                                    _.set($scope._quartoMapValues, "isShowCenters", false);
                                                });
                                            }
                                        })
                                        .on(`keyup.gmap-${eventHandlerId}`, function (e) {
                                            if (e.key === "Escape" && $scope._quartoMapValues.isShowCenters) {
                                                $scope.$apply(() => {
                                                    _.set($scope._quartoMapValues, "isShowCenters", false);
                                                });
                                            }
                                        });
                                }
                            } else {
                                if (!_.isNil(eventHandlerId)) {
                                    $(document)
                                        .off(`click.gmap-${eventHandlerId}`)
                                        .off(`keyup.gmap-${eventHandlerId}`);
                                    eventHandlerId = null;
                                }
                            }
                        });

                        eventChannels.broadcast("gMap", this.gMap);

                        $scope.$on("$destroy", () => {
                            eventChannels.broadcast("onDestroy", null);
                            if (!this.gMap) return;
                            google.maps.event.clearInstanceListeners(this.gMap);
                            this.gMap = null;
                            eventChannels.broadcast("gMap", this.gMap);
                        })
                    } else if (!_.isNull(centers)) {
                        if (zoom)
                            this.gMap.setZoom(zoom);

                        // pan to nearest center point, if the distance between current center and nearest center
                        // is gte to `panToCenter` value.
                        const computeDistance = google.maps.geometry.spherical.computeDistanceBetween;
                        const currentCenter = this.gMap.getCenter();
                        const nearestCenter = (() => {
                            const options = centers.map(center => ({
                              distance: currentCenter && center.centerPoint
                                ? Math.abs(computeDistance(currentCenter, center.centerPoint))
                                : Infinity,
                              centerPoint: center.centerPoint
                            }));
                            return _.minBy(options, "distance");
                        })();
                        if (panToCenter === true || (_.isNumber(panToCenter) && nearestCenter.distance >= panToCenter && nearestCenter.centerPoint))
                            this.gMap.panTo(nearestCenter.centerPoint);
                    }
                },

                /**
                 * Get center point which passed-in to `setOptions()`.
                 */
                getCenters() {
                    return _.get($scope, "_quartoMapValues.centers", null);
                },

                /**
                 * Subscribe to an event.
                 * @param {string} eventName
                 * @param {function} callback
                 * @returns Function to unsubscribe event.
                 */
                addListener(eventName, callback) {
                    return eventChannels.subscribe(eventName, callback);
                },

                /**
                 * Open/close panels of QuartoMap.
                 * @param {string} areaName - Allowed values are ["filter", "info"].
                 * @param {Boolean} isOpen
                 */
                setOpen(areaName, isOpen) {
                    ({
                        filter: isOpen => _.set($scope._quartoMapValues, "isFilterOpen", isOpen),
                        info: isOpen => _.set($scope._quartoMapValues, "isInfoOpen", isOpen)
                    })[areaName](isOpen);

                    if ($scope.$root.$$phase !== "$apply" && $scope.$root.$$phase !== "$digest") {
                        $scope.$apply();
                    }
                },

                /**
                 * Set width of panels.
                 * @param {"filter" | "info"} areaName - Area's name.
                 * @param {number} width - New width in pixels.
                 */
                setWidth(areaName, width) {
                    ({
                        filter: width_ => _.set($scope._quartoMapValues, "filterWidth", width_),
                        info: width_ => _.set($scope._quartoMapValues, "infoWidth", width_)
                    })[areaName](`${width}px`);
                },

                /**
                 * Append DOM element to panels of QuartoMap.
                 * @param {string} areaName - Allowed values are ["filter", "info", "content"].
                 * @param element - DOM element to append.
                 * @return element
                 */
                appendElement(areaName, element) {
                    _mapAreas[areaName].append(element);
                    return element;
                },
            });

            if (!_.isEmpty(directiveName))
                _.set($scope, directiveName, quartoMap);

            if (shouldFillHeight) {
                const iParent = iElement.parent();
                if (!iParent[0].hasAttribute('ng-controller')) {
                    console.warn(MESSAGE_FILL_HEIGHT_MISUSE);
                    return;
                }
                iParent.css({
                    "display": "flex",
                    "flex-direction": "column",
                    "width": "100%",
                    "height": "100%"
                });
                iElement.css({
                    "flex": "1"
                });
            }
        }
    };
});


app.directive('mapTableContentKeyValue', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {contents: '=mapTableContentKeyValue'},
        template: '<div kendo-grid options="kOpt" k-rebind="kOpt"></div>',
        controller: function ($scope) {
            if (!Boolean($scope.contents)) return;
            const columns = [
                {headerTemplate: "", field: "type", width: 100},
                {title: "Value", field: "value", width: 150, template: (dataItem) => dataItem.value}
            ]
            const dataSource = Object.keys($scope.contents)
                .map(a => ({"type": a, "value": $scope.contents[a]}));
            $scope.kOpt = {columns, dataSource};
        }
    };
});

app.directive('mapTableContentBasic', function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {contents: '=mapTableContentBasic'},
        template: '<div kendo-grid options="kOpt" k-rebind="kOpt"></div>',
        controller: function ($scope) {
            if (!Boolean($scope.contents)) return;
            const columns = $scope.contents.headers;
            const dataSource = $scope.contents.body;
            $scope.kOpt = {columns, dataSource};
        }
    };
});
